import React from 'react';
import { DemeterCommodity } from '../../../../Generated/Raven-Demeter';
import formattingService from '../../../Services/Formatting/FormattingService';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from './NewsComponents.module.scss';

interface INewsCardProps {
    title: string;
    date?: string | null;
    summary?: string | null;
    geography?: string | null;
    commodity: string;
    onClick: () => void;
}

const NewsCard: React.FC<INewsCardProps> = (props) => {
    const [translations] = useLanguage();

    return (
        <div className={styles.card} onClick={props.onClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && props.onClick()}>
            <div className={styles.card_top}>
                <span className={styles.card_commodity}>{translations.commodity[props.commodity as DemeterCommodity]}</span>
            </div>
            <div className={styles.card_title}>{props.title}</div>
            <div className={styles.card_meta}>
                {props.date && <span className={styles.card_date}>{formattingService.toShortDayMonthYear(props.date)}</span>}
                {props.geography && <span className={styles.card_geography}>{props.geography}</span>}
            </div>
            {props.summary && <div className={styles.card_summary}>{props.summary}</div>}
        </div>
    );
};

export default NewsCard;
